// @flow
import moment from 'moment';
import DateRange from 'common/domain/DateRange';

export type HistoryDateRangeType =
| 'lastMonth'
| 'lastThreeMonths'
| 'lastSixMonths'
| 'lastYear'
| 'lastTwoYears';

type RangeConverters = { [range: HistoryDateRangeType]: (to: moment) => DateRange };
const RANGE_CONVERTERS: RangeConverters = {
  'lastMonth': to => new DateRange({ from: to.clone().subtract(1, 'months'), to: to }),
  'lastThreeMonths': to => new DateRange({ from: to.clone().subtract(3, 'months'), to: to }),
  'lastSixMonths': to => new DateRange({ from: to.clone().subtract(6, 'months'), to: to }),
  'lastYear': to => new DateRange({ from: to.clone().subtract(1, 'year'), to: to }),
  'lastTwoYears': to => new DateRange({ from: to.clone().subtract(2, 'year'), to: to }),
};

export function allDateRanges(): HistoryDateRangeType[] {
  return Object.keys(RANGE_CONVERTERS);
}

export function asDateRange(range: HistoryDateRangeType) {
  const lastWeek = moment().startOf('isoWeek').subtract(1, 'day');
  return RANGE_CONVERTERS[range](lastWeek);
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/domain/HistoryDateRange.js